'use client';
import { useEffect, useMemo, useState } from 'react';
import { ONE_MINUTE } from '@/helpers/dateTime';
import { useGetCommonStore } from '@/store';
import { getSpinsLeftAmount } from '../helpers/fortuneWheel';

export const useFortuneWheel = () => {
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const wheelLootboxes = useCommonStore.use.wheelLootboxes();

  const [spinsLeftAmount, setSpinsLeftAmount] = useState(
    getSpinsLeftAmount(wheelLootboxes)
  );

  useEffect(() => {
    if (!isAuthenticated) return;

    setSpinsLeftAmount(getSpinsLeftAmount(wheelLootboxes));

    const interval = setInterval(() => {
      setSpinsLeftAmount(getSpinsLeftAmount(wheelLootboxes));
    }, ONE_MINUTE);

    return () => clearInterval(interval);
  }, [wheelLootboxes, isAuthenticated]);

  const isDailySpinsLimit = useMemo(
    () => isAuthenticated && spinsLeftAmount <= 0,
    [spinsLeftAmount, isAuthenticated]
  );

  return {
    spinsLeftAmount,
    isDailySpinsLimit,
  };
};
